export default "__VITE_ASSET__b$$uGkRv__"